module.exports = __webpack_public_path__ + "img/frontal.87ba65ad.jpg";